export const APP_EDGE_DOCK_HEIGHT = 76
